var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Shevron.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const Shevron = ({
  color = 'rgba(53, 59, 96, 0.25)',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "100%",
  height: "100%",
  viewBox: "0 0 5 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M0.20956 0.210464C-0.0698533 0.489877 -0.0698533 0.941237 0.20956 1.22065L2.98936 4.00045L0.20956 6.78025C-0.0698533 7.05967 -0.0698533 7.51103 0.20956 7.79044C0.488973 8.06985 0.940333 8.06985 1.21975 7.79044L4.50822 4.50196C4.78764 4.22255 4.78764 3.77119 4.50822 3.49178L1.21975 0.2033C0.947497 -0.068949 0.488973 -0.068949 0.20956 0.210464Z",
    fill: color
  })
});